export default class {
    _id;
    _name;
    _isHead;
    _address;
    _globalorganization;
    _createdOn;
    _regions;

    get id() {
        return this._id
    }

    set id(value) {
        this._id = value
    }


    get name() {
        return this._name
    }

    set name(value) {
        this._name = value
    }

    get isHead() {
        return this._isHead
    }

    set isHead(value) {
        this._isHead = value
    }

    get address() {
        return this._address;
    }

    set address(value) {
        this._address = value;
    }

    get globalorganization() {
        return this._globalorganization
    }

    set globalorganization(value) {
        this._globalorganization = value
    }

    get createdOn() {
        return this._createdOn
    }

    set createdOn(value) {
        this._createdOn = value
    }

    get regions() {
        return this._regions;
    }

    set regions(value) {
        this._regions = value;
    }
}